<template>
  <div class="flex justify-center">
    <div class="text-sm py-3">{{title}}</div>
  </div>
  <div class="flex justify-center">
    <h1 class="text-3xl pt-6 pb-5">{{number}}</h1>
  </div>
  <hr>
  <div class="flex flex-col h-80">
    <div class="btn-box pt-10">
      <div v-for="item in btnConf" :key="item.id">
        <div class="flex justify-center">
          <button v-if="item.color == 'red'" :loading="loading" :class="'p-2 mb-7 w-80 bg-red-400 hover:bg-red-300 text-white rounded'" @click="$emit('answer', item)">{{item.text}}</button>
          <button v-if="item.color == 'blue'" :loading="loading" :class="'p-2 mb-7 w-80 bg-blue-400 hover:bg-blue-300 text-white rounded'" @click="$emit('answer', item)">{{item.text}}</button>
          <button v-if="item.color == 'green'" :loading="loading" :class="'p-2 mb-7 w-80 bg-green-400 hover:bg-green-300 text-white rounded'" @click="$emit('answer', item)">{{item.text}}</button>
          <button v-if="item.color == 'yellow'" :loading="loading" :class="'p-2 mb-7 w-80 bg-yellow-400 hover:bg-yellow-300 text-white rounded'" @click="$emit('answer', item)">{{item.text}}</button>
        </div>
      </div>
      <div class="flex justify-center">
        <button :loading="loading" class="p-2 mt-10 w-80 bg-transparent hover:bg-blue-100 text-gray-600 hover:text-blue-500 border border-gray-300 hover:border-transparent rounded" @click="$emit('answer', nextBtnConf)">進む</button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent} from 'vue'
export default defineComponent({
  props: {
    title: { type: String, default: '' },
    loading: { type: Boolean, default: false, required: true },
    number: { type: Number, default: 1, required: true },
    btnConf: { type: Array, required: true },
  },
  emits: ['answer'],
  setup() {
    return {
      nextBtnConf: {
        text: '進む',
        color: '',
        neworpay: 0,
        trade: 0
      }
    }
  }
})
</script>

<style>
.btn-box {
  color: v-bind(color);
}
</style>